import React, { Component } from 'react';
import Inbox from './Inbox.js';

export default class InboxLaporan extends Component {
  render() {
    return (
      <Inbox type='TNDE_LAPORAN'/>
    );
  }
}
